function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable no-mixed-spaces-and-tabs, jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Message from 'js/components/atoms/Label/Message';
import { AUTH_ROUTE_PATH } from 'js/constants/routes';
import { localizedText } from 'js/localization';
import { countries } from './countries';
import { plans } from './plans';
import { Label, Box } from './style';
var SIGN_UP_TITLE = localizedText.SIGN_UP_TITLE,
    SIGN_UP_DESCRIPTION = localizedText.SIGN_UP_DESCRIPTION,
    SIGN_UP_SUBMIT_LABEL = localizedText.SIGN_UP_SUBMIT_LABEL,
    SIGN_UP_SUBMITTING_LABEL = localizedText.SIGN_UP_SUBMITTING_LABEL,
    ALREADY_HAVE_ACCOUNT_TEXT = localizedText.ALREADY_HAVE_ACCOUNT_TEXT,
    LOG_IN_LINK_TEXT = localizedText.LOG_IN_LINK_TEXT;

var SignupPage =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SignupPage, _React$Component);

  function SignupPage(props) {
    var _this;

    _classCallCheck(this, SignupPage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SignupPage).call(this, props));
    _this.state = {
      selectedInstitutionType: _this.props.institutionTypeOptions[0].value,
      selectedPlan: plans[0].value,
      selectedCountry: countries[0].name
    };
    _this.onSelectInstitutionType = _this.onSelectInstitutionType.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onSelectPlan = _this.onSelectPlan.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.onSelectCountry = _this.onSelectCountry.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.prepopulate = _this.prepopulate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getElementAndFill = _this.getElementAndFill.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(SignupPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.prepopulate();
    }
  }, {
    key: "onSelectInstitutionType",
    value: function onSelectInstitutionType(event) {
      this.setState({
        selectedInstitutionType: event.target.value
      });
    }
  }, {
    key: "onSelectCountry",
    value: function onSelectCountry(event) {
      this.setState({
        selectedCountry: event.target.value
      });
    }
  }, {
    key: "onSelectPlan",
    value: function onSelectPlan(event) {
      this.setState({
        selectedPlan: event.target.value
      });
    }
  }, {
    key: "getElementAndFill",
    value: function getElementAndFill(inputId, val) {
      var input = document.getElementById(inputId);
      input.value = val;
    }
  }, {
    key: "prepopulate",
    value: function prepopulate() {
      if (this.props.premiumTrial && this.props.user.first_name) {
        this.getElementAndFill('first_name', this.props.user.first_name);
        this.getElementAndFill('last_name', this.props.user.last_name);
        this.getElementAndFill('email', this.props.user.email);
        this.getElementAndFill('institution_name', this.props.user.institution_name);
        this.getElementAndFill('institution_type', this.props.user.institution_type);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var messages = this.props.messages;
      return React.createElement("div", null, React.createElement("strong", {
        className: this.props.premiumTrial ? ' hide' : ' show'
      }, SIGN_UP_TITLE), React.createElement("br", null), React.createElement("small", {
        className: "form-group".concat(this.props.premiumTrial ? ' hide' : ' show')
      }, SIGN_UP_DESCRIPTION), React.createElement(Message, {
        message: this.props.messages.success,
        type: 'success'
      }), React.createElement(Message, {
        message: this.props.messages.error,
        type: 'error'
      }), messages.success ? React.createElement("form", {
        method: "POST",
        action: "#",
        onSubmit: this.props.onConfirmAccount
      }, React.createElement("label", {
        htmlFor: "email"
      }, "Confirm e-mail:", React.createElement("br", null), React.createElement("input", {
        className: "form-control",
        type: "email",
        id: "email",
        name: "email",
        required: true
      })), React.createElement("br", null), React.createElement("label", {
        htmlFor: "email"
      }, "Enter confirmation code:", React.createElement("br", null), React.createElement("input", {
        className: "form-control",
        type: "text",
        name: "code"
      })), React.createElement("br", null), React.createElement("br", null), React.createElement("br", null), React.createElement("button", {
        type: "submit",
        className: "btn btn-primary"
      }, "Confirm account"), React.createElement("br", null)) : React.createElement("form", {
        onSubmit: this.props.onSubmit
      }, React.createElement("div", {
        className: "form-group"
      }, React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-xs-12 col-sm-6"
      }, React.createElement("label", {
        htmlFor: "first_name"
      }, this.props.formLabels.firstName, React.createElement("input", {
        className: "form-control",
        type: "text",
        id: "first_name",
        name: "first_name",
        required: true
      }))), React.createElement("div", {
        className: "col-xs-12 col-sm-6"
      }, React.createElement("label", {
        htmlFor: "last_name"
      }, this.props.formLabels.lastName, React.createElement("input", {
        className: "form-control",
        type: "text",
        id: "last_name",
        name: "last_name",
        required: true
      }))))), React.createElement("div", {
        className: "form-group"
      }, React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-xs-12 col-sm-6"
      }, React.createElement("label", {
        htmlFor: "email"
      }, this.props.formLabels.email, React.createElement("input", {
        className: "form-control",
        type: "email",
        id: "email",
        name: "email",
        required: true
      }))), React.createElement("div", {
        className: "col-xs-12 col-sm-6"
      }, React.createElement("label", {
        htmlFor: "password"
      }, this.props.formLabels.password, React.createElement("input", {
        className: "form-control",
        type: "password",
        id: "password",
        name: "password",
        required: true
      }))))), React.createElement("div", {
        className: "form-group"
      }, React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-xs-12 col-sm-6"
      }, React.createElement("label", {
        htmlFor: "institution_name"
      }, this.props.formLabels.institutionName, React.createElement("input", {
        className: "form-control",
        type: "text",
        id: "institution_name",
        name: "institution_name",
        required: true
      }))), React.createElement(Box, {
        className: "col-xs-4 col-sm-3"
      }, React.createElement(Label, {
        htmlFor: "institution_type"
      }, "Country", React.createElement("br", null), React.createElement("select", {
        className: "form-control",
        id: "country",
        name: "country",
        value: this.state.selectedCountry,
        onChange: this.onSelectCountry,
        required: true
      }, countries.map(function (option, index) {
        return React.createElement("option", {
          key: index,
          value: option.name
        }, option.name);
      })))))), React.createElement("div", {
        className: "form-group"
      }, React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-xs-12 col-sm-8"
      }, React.createElement("label", {
        htmlFor: "institution_type"
      }, "Choose plan", React.createElement("br", null), React.createElement("select", {
        className: "form-control",
        id: "choose_plan",
        name: "choose_plan",
        value: this.state.selectedPlan,
        onChange: this.onSelectPlan,
        required: true
      }, plans.map(function (option, index) {
        return React.createElement("option", {
          key: index,
          value: option.value
        }, option.title);
      })))))), React.createElement("div", {
        className: "form-group"
      }, React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-xs-12 col-sm-8"
      }, React.createElement("label", {
        htmlFor: "institution_type"
      }, this.props.formLabels.institutionType, React.createElement("br", null), React.createElement("select", {
        className: "form-control",
        id: "institution_type",
        name: "institution_type",
        value: this.state.selectedInstitutionType,
        onChange: this.onSelectInstitutionType,
        required: true
      }, this.props.institutionTypeOptions.map(function (option, index) {
        return React.createElement("option", {
          key: index,
          value: option.value
        }, option.title);
      })))))), React.createElement("div", {
        className: "form-group".concat(this.props.premiumTrial ? ' hide' : ' show')
      }, this.props.isSubmitting ? React.createElement("button", {
        disabled: true,
        type: "submit",
        className: "btn btn-primary"
      }, SIGN_UP_SUBMITTING_LABEL) : React.createElement("button", {
        type: "submit",
        className: "btn btn-primary"
      }, SIGN_UP_SUBMIT_LABEL)), React.createElement("div", {
        className: "form-group".concat(this.props.premiumTrial ? ' hide' : ' show')
      }, React.createElement("span", null, ALREADY_HAVE_ACCOUNT_TEXT, " ", React.createElement(Link, {
        to: AUTH_ROUTE_PATH
      }, LOG_IN_LINK_TEXT)))));
    }
  }]);

  return SignupPage;
}(React.Component);

export { SignupPage as default };
SignupPage.propTypes = {
  messages: PropTypes.array,
  onConfirmAccount: PropTypes.bool.isRequired,
  institutionTypeOptions: PropTypes.array.isRequired,
  formLabels: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  premiumTrial: PropTypes.bool,
  user: PropTypes.object
};